import * as CONSTANTS from './constants'
import { DemandbaseAudiences } from 'constants/DemandbaseAudiences'

export const geoFilter = {
  'field': CONSTANTS.GEO_FILTER_TYPES.STATE,
  'operator': CONSTANTS.GEO_FILTER_OPERATORS.IS_ANY,
  'value': []
}

export const companyTagsFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.COMPANY_CATEGORIES,
  'operator': CONSTANTS.CATEGORY_FILTER_OPERATORS.IS_ANY,
  'value': []
}

export const marketTagsFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.MARKET_CATEGORIES,
  'operator': CONSTANTS.CATEGORY_FILTER_OPERATORS.IS_ANY,
  'value': []
}

export const techTagsFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.TECH_TAGS,
  'operator': CONSTANTS.CATEGORY_FILTER_OPERATORS.IS_ANY,
  'value': []
}

export const headquarterStateFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_STATE,
  'operator': CONSTANTS.CATEGORY_FILTER_OPERATORS.IS_ANY,
  'value': []
}

export const headquarterCountryFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_COUNTRY,
  'operator': CONSTANTS.CATEGORY_FILTER_OPERATORS.IS_ANY,
  'value': []
}

export const headquarterPostalCodeFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_POSTAL_CODE,
  'operator': CONSTANTS.CATEGORY_FILTER_OPERATORS.IS_ANY,
  'value': []
}

export const annualRevenueFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.REVENUE,
  'operator': CONSTANTS.REVENUE_FILTER_OPERATORS.BTW,
  'value': '$0-$1M'
}

export const firmographicFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.EMPLOYEES,
  'operator': CONSTANTS.EMPLOYEES_FILTER_OPERATORS.BTW,
  'value': { min: 0, max:10 }
}

export const siteVisitsFilter = {
  'field': CONSTANTS.DISPLAY_WHEN_FILTER_TYPES.SITE_VISITS,
  'operator': CONSTANTS.SITE_VISITS_OPERATORS.BTW,
  'value': { min: 0, max:1 }
}

export const urlPathFilter = {
  'field': CONSTANTS.URL_FILTER_TYPES.URL_PATH,
  'operator': CONSTANTS.URL_FILTER_OPERATORS.INCLUDES_ANY,
  'value': [CONSTANTS.EMPTY_STRING]
}

export const urlHostFilter = {
  'field': CONSTANTS.URL_FILTER_TYPES.URL_HOST,
  'operator': CONSTANTS.URL_FILTER_OPERATORS.IS_ANY,
  'value': [CONSTANTS.EMPTY_STRING]
}

export const urlQueryFilter = {
  'field': CONSTANTS.URL_FILTER_TYPES.URL_QUERY,
  'operator': CONSTANTS.URL_FILTER_OPERATORS.IS_ANY,
  'value': [CONSTANTS.EMPTY_STRING]
}

export const salesforceFilter = {
  'field': CONSTANTS.SALESFORCE_FILTER,
  'operator': CONSTANTS.SALESFORCE_OPERATORS.IS,
  'value': true
}

export const targetedAccountsFilter = {
  'field': CONSTANTS.TARGETED_ACCOUNTS_FILTER,
  'operator': CONSTANTS.TARGETED_ACCOUNTS_OPERATORS.IS,
  'value': true
}

export const leandataFilter = {
  'field': CONSTANTS.LEANDATA_FILTER,
  'operator': CONSTANTS.TARGETED_ACCOUNTS_OPERATORS.IS,
  'value': true,
}

export const participantAction = {
  'type' : CONSTANTS.ACTION_TYPES.PARTICIPANT,
  'options' : {
    'teamId': null, // teamId if the participant is a team
    'userIds' : [], // list of users to add
    'addType' : CONSTANTS.PARTICIPANT_ADD_TYPES.ONE, // either ADD_ONE or ADD_ALL
    'isAccountOwner' : true // true if the added user should also be set as the account owner, false otherwise
  }
}

export const salesforceAction = {
  'type' : CONSTANTS.ACTION_TYPES.SALESFORCE_PARTICIPANT
}

export const leandataAction = {
  'type' : CONSTANTS.ACTION_TYPES.LEANDATA_PARTICIPANT
}

export const targetedAccountsAction = {
  'type' : CONSTANTS.ACTION_TYPES.ABM_PARTICIPANT
}

export const demandbaseAudienceFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_AUDIENCE,
  'operator': CONSTANTS.DEMANDBASE_FILTER_OPERATORS.IS_ANY,
  'value': DemandbaseAudiences[0].value
}

export const demandbaseIndustryFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_INDUSTRY,
  'operator': CONSTANTS.DEMANDBASE_FILTER_OPERATORS.IS_ANY,
  'value': ''
}

export const demandbaseSubIndustryFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_SUB_INDUSTRY,
  'operator': CONSTANTS.DEMANDBASE_FILTER_OPERATORS.IS_ANY,
  'value': ''
}

export const demandbaseEmployeeCountFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_EMPLOYEE_COUNT,
  'operator': CONSTANTS.DEMANDBASE_FILTER_OPERATORS.BTW,
  'value': { min: 0, max:10 }
}

export const demandbaseEmployeeRangeFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_EMPLOYEE_RANGE,
  'operator': CONSTANTS.DEMANDBASE_FILTER_OPERATORS.IS_ANY,
  'value': ''
}

export const demandbaseMarketingAliasFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_MARKETING_ALIAS,
  'operator': CONSTANTS.DEMANDBASE_FILTER_OPERATORS.IS_ANY,
  'value': ''
}

export const demandbaseAnnualSalesFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_ANNUAL_SALES,
  'operator': CONSTANTS.DEMANDBASE_FILTER_OPERATORS.BTW,
  'value': { min: 0, max:10 }
}

export const demandbaseRevenueRangeFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_REVENUE_RANGE,
  'operator': CONSTANTS.DEMANDBASE_FILTER_OPERATORS.IS_ANY,
  'value': ''
}

export const demandbaseHeadquarterCityFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_CITY,
  'operator': CONSTANTS.DEMANDBASE_FILTER_OPERATORS.IS_ANY,
  'value': ''
}

export const demandbaseHeadquarterStateFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_STATE,
  'operator': CONSTANTS.DEMANDBASE_FILTER_OPERATORS.IS_ANY,
  'value': []
}

export const demandbaseHeadquarterCountryFilter = {
  'field': CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_COUNTRY,
  'operator': CONSTANTS.DEMANDBASE_FILTER_OPERATORS.IS_ANY,
  'value': []
}

export const newRuleModel = {
  valid: false,
  loading: true,
  error: null,
  data: {
    item: {
      name: '',
      conditions: [],
      action: participantAction,
      status: "ENABLED"
    }
  }
}

export const availabilityFilter = {
  'field': CONSTANTS.AVAILABILITY_FILTER,
  'operator': CONSTANTS.AVAILABILITY_FILTER_OPERATORS.IS_ANY,
  'value': true
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/rules/models.js